const index = {
  name: 'trainingEnrollQueryResult',
  path: 'result',
  props: true,
  component: resolve => require(['../../../../../../pages/portal/sbs/training/enroll-query/result'], resolve)
}

export default index
